import { connect } from 'react-redux';
import App from './app';

const mapState = (state) => ({
  ...state.mailToTarget,
  totalSteps: state.mailToTarget.hideLookupStep ? 3 : 4,
  selectableElectorates: state.mailToTarget.electorates.filter(
    (e) => e.id !== 'list'
  ),
  selectableParties: state.mailToTarget.parties.filter(
    (p) => p.id !== 'list' && p.id !== 'independent'
  ),
  selectedElectorate: state.mailToTarget.electorates.find(
    (e) => e.id === state.mailToTarget.userInput.selectedElectorateId
  ),
  selectedParty: state.mailToTarget.parties.find(
    (p) => p.id === state.mailToTarget.userInput.selectedPartyId
  ),
  selectedMP: state.mailToTarget.mps.find(
    (mp) => mp.id === state.mailToTarget.userInput.selectedMPId
  )
});
const mapDispatch = (dispatch) => ({
  sendEmail: () => dispatch.mailToTarget.sendEmail(),
  generateAndSetEmailMessage: () =>
    dispatch.mailToTarget.generateAndSetEmailMessage(),
  setUserInput: (userInput) => dispatch.mailToTarget.setUserInput(userInput)
});

export default connect(mapState, mapDispatch)(App);
